import { axiosBaseQuery } from '@src/service';
import { createApi } from '@reduxjs/toolkit/query/react';

import { IActivateRequest, IResetPasswordRequest, ISignInResponse, ITermsResponse } from './types';
import { ISignInForm } from '@src/features/auth/pages/sign-in-page/types';
import { IVerifyEmailForm } from '@src/features/auth/pages/verify-email-page/types';


export const authApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'authApi',
  endpoints: (builder) => ({
    activate: builder.mutation<void, IActivateRequest>({
      query: (params) => ({
        url: '/api/v1/activate',
        method: 'GET',
        params,
      })
    }),
    signIn: builder.mutation<ISignInResponse, ISignInForm>({
      query: (data) => ({
        url: '/api/v1/authenticate',
        method: 'POST',
        data,
      })
    }),
    verifyEmail: builder.mutation<void, IVerifyEmailForm>({
      query: (data) => ({
        url: '/api/v1/reset-password-request',
        method: 'POST',
        data,
      }),
    }),
    resetPassword: builder.mutation<void, IResetPasswordRequest>({
      query: (data) => ({
        url: '/api/v1/reset-password',
        method: 'POST',
        data,
      })
    }),
    terms: builder.query<ITermsResponse, void>({
      query: () => ({
        url: '/api/v1/terms',
        method: 'GET',
      }),
    }),
    acceptTerms: builder.mutation<void, void>({
      query: () => ({
        url: '/api/v1/terms/accept',
        method: 'POST',
        data: {},
      }),
    }),
  }),
});

export const {
  useSignInMutation,
  useActivateMutation,
  useVerifyEmailMutation,
  useResetPasswordMutation,
  useTermsQuery,
  useAcceptTermsMutation,
} = authApi;